module.exports = __webpack_public_path__ + "static/media/expertise-icon.59ae4268.svg";